import router from "@/router";

const menu = {
  state: {
    // 后台侧边栏
    menuList: [
      {
        name: "用户管理",
        path: "/userManagement",
        icon: require("@/assets/imgs/menu/user.png"),
        img: require("@/assets/imgs/menu/user-on.png"),
        permission: "",
        show: true,
      },
      {
        title: "角色管理",
        url: "/roleManagement",
        icon: require("@/assets/imgs/menu/role.png"),
        img: require("@/assets/imgs/menu/role-on.png"),
        permission: "",
        show: false,
      },
      {
        name: "部门管理",
        url: "/departmentManagement",
        icon: require("@/assets/imgs/menu/dept.png"),
        img: require("@/assets/imgs/menu/dept-on.png"),
        permission: "",
        show: true,
      },
      {
        name: "菜单管理",
        url: "/menuManagement",
        icon: require("@/assets/imgs/menu/menu.png"),
        img: require("@/assets/imgs/menu/menu-on.png"),
        permission: "",
        show: true,
      },
      {
        name: "通知公告",
        url: "/noticeManagement",
        icon: require("@/assets/imgs/menu/notice.png"),
        img: require("@/assets/imgs/menu/notice-on.png"),
        permission: "",
        show: true,
      },
      {
        name: "应用管理",
        url: "/clientManagement",
        icon: require("@/assets/imgs/menu/client.png"),
        img: require("@/assets/imgs/menu/client-on.png"),
        permission: "",
        show: true,
      },
      {
        name: "租户管理",
        url: "/tenantManagement",
        icon: require("@/assets/imgs/menu/tenant.png"),
        img: require("@/assets/imgs/menu/tenant-on.png"),
        permission: "",
        show: true,
        childrenList: [
          {
            name: "租户列表",
            url: "/tenantList",
            parentPath: "/tenantManagement",
            permission: "",
            show: true,
          },
          {
            name: "租户套餐",
            url: "/tenantPackage",
            parentPath: "/tenantManagement",
            permission: "",
            show: true,
          },
        ],
      },
    ],
    // 首页菜单
    homeMenu: [
      {
        label: "校友管理",
        path: "/alumni",
        parentPath: "/alumniManagement",
        name: "alumni",
        icon: require("@/assets/imgs/menu/xy.png"),
        color: "#E2F7F4",
        permission: "/alumni",
        show: false,
        iconShow: true,
      },
    ],
    collapsed: false,
    menuChildrenList: [],
    activeIcon: "",
    loginUrl: process.env.VUE_APP_BASE_API,
    // ownUrl: "http://192.168.0.53:9118/",
    ownUrl: "https://www.mingxiaobang.cn/sccpPlatform/",// 公版
  },
  getters: {},
  mutations: {
    // 修改一级侧边栏展开收起
    changeCollapsed(state) {
      state.collapsed = !state.collapsed;
    },
    childMenu(state, val) {
      state.menuList.forEach((item) => {
        if (val.name == item.name) {
          state.menuChildrenList = item.children;
          sessionStorage.setItem(
            "menuChildrenList",
            JSON.stringify(item.children)
          );
        }
      });
    },
    setMenu(state) {
      let permission =
        sessionStorage.getItem("pageAuth") &&
        JSON.parse(sessionStorage.getItem("pageAuth"));
      state.menuList.forEach((item) => {
        if (item.children) {
          item.children.forEach((om) => {
            if (permission?.includes(om.permission)) {
              om.show = true;
            } else {
              om.show = false;
            }
          });
        } else {
          if (permission?.includes(item.permission)) {
            item.show = true;
          } else {
            item.show = false;
          }
        }
      });
      if (state.menuList?.filter((f) => f.show)?.length) {
        //权限第一个元素有children
        const routeList = router.options.routes[0];
        if (state.menuList?.filter((f) => f.show)?.[0]?.children?.length) {
          routeList.redirect = state.menuList?.filter(
            (f) => f.show
          )?.[0]?.children?.[0]?.path;
          // 实现父级图标高亮
        } else {
          routeList.redirect = state.menuList?.filter((f) => f.show)?.[0]?.path;
        }
      }
    },
    setIcon(state, val) {
      state.activeIcon = val;
    },
  },
  actions: {},
};
export default menu;
